import React, { useEffect, useRef, useState } from 'react';
import AzureMapMarker from './AzureMapMarker';

const AzureMapPointOnClick = ({
    map,
    center,
    onMapClick
}) => {
    const [clickPosition, setClickPosition] = useState(center);

    useEffect(() => {
        if (center) {
            setClickPosition(center);
        }
    }, [center]);

    useEffect(() => {
        if (!map) return;

        const handleMapClick = (e) => {
            console.log("AzureMap click at:", e.position);
            const position = [e.position[1], e.position[0]]; // [lat, lng]
            setClickPosition(position);
            if (onMapClick) {
                onMapClick({
                    lat: position[0],
                    lng: position[1]
                });
            }
        };

        map.events.add('click', handleMapClick);

        return () => {
            map.events.remove('click', handleMapClick);
        };
    }, [map, onMapClick]);

    return clickPosition ? (
        <AzureMapMarker
            map={map}
            position={clickPosition}
            popup={`Coordenadas: ${clickPosition[0]}, ${clickPosition[1]}`}
        />
    ) : null;
};

export default AzureMapPointOnClick;
